import { createSlice } from '@reduxjs/toolkit';
import { startOfMonth, endOfMonth, addMonths, format } from 'date-fns';
import { DATE_RANGE_SELECTOR } from '../../constants';

const filterSlice = createSlice({
  name: 'filter',
  initialState: {
    dateRange: DATE_RANGE_SELECTOR[2],
    startDateRange : format(startOfMonth(addMonths(new Date(), -1)), 'yyyy-MM-dd'),
    endDateRange : format(endOfMonth(addMonths(new Date(), -1)), 'yyyy-MM-dd'),
  },
  reducers: {
    setDateRange: (state, action) => {
      state.startDateRange = action.payload.startDate;
      state.endDateRange = action.payload.endDate;
    },
  },
});

export const actions = filterSlice.actions;
export default filterSlice.reducer;
